import styled from "styled-components";

/** Lista da página — sem max-height / scroll interno */
export const PageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  width: 100%;
  box-sizing: border-box;
  padding: 0.25rem 0 2rem;
`;

export const ProjectSection = styled.section`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--border-default);
  border-radius: 14px;
  background: var(--surface-1);
  padding: 1rem 1.1rem 1.25rem;
`;

export const ProjectHeader = styled.header`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--border-subtle);
`;

export const ProjectTitle = styled.h2`
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-heading);
  line-height: 1.3;
`;

export const ProjectMeta = styled.p`
  margin: 0.25rem 0 0;
  font-size: 0.85rem;
  color: var(--text-secondary);
`;

export const ProjectLink = styled.button`
  appearance: none;
  border: 1px solid var(--border-default);
  background: var(--accent-soft);
  color: var(--text-heading);
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.45rem 0.85rem;
  border-radius: 999px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    border-color: var(--accent);
  }
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  width: 100%;
  box-sizing: border-box;

  @media screen and (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const CardContainer = styled.button`
  appearance: none;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  min-height: 0;
  margin: 0;
  padding: 0.85rem;
  text-align: left;
  font-family: inherit;
  color: inherit;
  background: var(--surface-2);
  border-radius: 12px;
  border: 1px solid var(--border-default);
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  box-sizing: border-box;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    border-color: var(--accent);
    box-shadow: var(--shadow-md);
  }

  &:active {
    transform: translateY(-1px);
  }
`;

export const CardImage = styled.img`
  width: 100%;
  height: 140px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 0.75rem;
  background: var(--surface-1);

  @media screen and (max-width: 768px) {
    height: 120px;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  width: 100%;
  min-width: 0;
`;

export const Title = styled.h3`
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.3;
  overflow-wrap: anywhere;
`;

export const Info = styled.p`
  font-size: 0.85rem;
  margin: 0;
  color: var(--text-secondary);
  line-height: 1.4;
  overflow-wrap: anywhere;
`;

export const EmptyMessage = styled.p`
  margin: 1.5rem 0;
  text-align: center;
  color: var(--text-secondary);
  font-size: 0.95rem;
`;

/* Compat com imports legados */
export const Wrapper = PageList;
export const ScoreContainer = styled.div``;
export const MobileScoreContainer = styled.div``;
